import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ConstructionIcon(props: IconProps) {
    return <Icon {...props} iconKey={"construction"}/>
}
